export const lerp = (start: number, end: number, amt: number) => {
    return (1 - amt) * start + amt * end
}
export const easeInOutQuad = (t: number) => {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t
}
export const tweenObjectParamsTo = (
    start: { [key: string]: number },
    end: { [key: string]: number },
    duration: number,
    callback: (value: { [key: string]: number }) => void,
    ease: (t: number) => number = t => t,
) => {
    const startTime = Date.now()
    const update = () => {
        const elapsed = Date.now() - startTime
        const value = Object.keys(start).reduce(
            (acc, key) => {
                acc[key] = lerp(start[key], end[key], ease(elapsed / duration))
                return acc
            },
            {} as { [key: string]: number },
        )
        callback(value)
        if (elapsed < duration) {
            requestAnimationFrame(update)
        }
    }
    update()
}
